/**
 * belfastpilates-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesDevelopmentappspotcom) {
      root.BelfastpilatesDevelopmentappspotcom = {};
    }
    root.BelfastpilatesDevelopmentappspotcom.NotificationRequest = factory(root.BelfastpilatesDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The NotificationRequest model module.
   * @module model/NotificationRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>NotificationRequest</code>.
   * @alias module:model/NotificationRequest
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>NotificationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NotificationRequest} obj Optional instance to populate.
   * @return {module:model/NotificationRequest} The populated <code>NotificationRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('apiUrl')) {
        obj['apiUrl'] = ApiClient.convertToType(data['apiUrl'], 'String');
      }
      if (data.hasOwnProperty('authenticationKeyProvider')) {
        obj['authenticationKeyProvider'] = ApiClient.convertToType(data['authenticationKeyProvider'], 'String');
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('contentType')) {
        obj['contentType'] = ApiClient.convertToType(data['contentType'], 'String');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('maxRetries')) {
        obj['maxRetries'] = ApiClient.convertToType(data['maxRetries'], 'Number');
      }
      if (data.hasOwnProperty('msgToSendToUser')) {
        obj['msgToSendToUser'] = ApiClient.convertToType(data['msgToSendToUser'], 'String');
      }
      if (data.hasOwnProperty('notificationType')) {
        obj['notificationType'] = ApiClient.convertToType(data['notificationType'], 'String');
      }
      if (data.hasOwnProperty('numOfMilliSeconds')) {
        obj['numOfMilliSeconds'] = ApiClient.convertToType(data['numOfMilliSeconds'], 'Number');
      }
      if (data.hasOwnProperty('providerResponseData')) {
        obj['providerResponseData'] = ApiClient.convertToType(data['providerResponseData'], 'String');
      }
      if (data.hasOwnProperty('regIds')) {
        obj['regIds'] = ApiClient.convertToType(data['regIds'], ['String']);
      }
      if (data.hasOwnProperty('serviceProvider')) {
        obj['serviceProvider'] = ApiClient.convertToType(data['serviceProvider'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} apiUrl
   */
  exports.prototype['apiUrl'] = undefined;
  /**
   * @member {String} authenticationKeyProvider
   */
  exports.prototype['authenticationKeyProvider'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {String} contentType
   */
  exports.prototype['contentType'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {Number} maxRetries
   */
  exports.prototype['maxRetries'] = undefined;
  /**
   * @member {String} msgToSendToUser
   */
  exports.prototype['msgToSendToUser'] = undefined;
  /**
   * @member {String} notificationType
   */
  exports.prototype['notificationType'] = undefined;
  /**
   * @member {Number} numOfMilliSeconds
   */
  exports.prototype['numOfMilliSeconds'] = undefined;
  /**
   * @member {String} providerResponseData
   */
  exports.prototype['providerResponseData'] = undefined;
  /**
   * @member {Array.<String>} regIds
   */
  exports.prototype['regIds'] = undefined;
  /**
   * @member {String} serviceProvider
   */
  exports.prototype['serviceProvider'] = undefined;
  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/NotificationRequest.js